import '@ungap/global-this';
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from 'vue'
import Vuex from 'vuex'
import "@/conf/common.conf.js"
import populationStore from "@/store/population.store.js"
import lifemapStore from "@/store/lifemap.store.js"
import populationSelectpaneStore from "@/store/population.selectpane.store.js"
import lifemapSelectpaneStore from "@/store/lifemap.selectpane.store.js"
import App from '@/views/lifemap/LifemapApp.vue'

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        populationStore,
        lifemapStore,
        populationSelectpaneStore,
        lifemapSelectpaneStore,
    }
});

new Vue({
  render: h => h(App),
  store,
}).$mount('#app');
